import "core-js/modules/es.array.concat.js";
import { postReq, putReq, getReq, deleteReq } from './axios';
var BASE_URL = "".concat(apiUrl, "/borrower-external-credit");
export var getBorrowerExternalCredits = function getBorrowerExternalCredits(idNumber, body) {
  return getReq("".concat(BASE_URL, "/").concat(idNumber), body);
};
export var addBorrowerExternalCredits = function addBorrowerExternalCredits(idNumber, body) {
  return postReq("".concat(BASE_URL, "/").concat(idNumber), body);
};
export var editBorrowerExternalCredits = function editBorrowerExternalCredits(id, body) {
  return putReq("".concat(BASE_URL, "/").concat(id), body);
};
export var deleteBorrowerExternalCredits = function deleteBorrowerExternalCredits(id) {
  return deleteReq("".concat(BASE_URL, "/").concat(id));
};